import logo from "@/assets/images/logo.svg";
import { Stack } from "@mui/material";
import { FC } from "react";

type TLoginLogoProps = {};

export const LoginLogo: FC<TLoginLogoProps> = () => {
  return (
    <Stack gap={1} alignItems="center">
      <Stack>
        <img width={240} src={logo} alt="logo" />
      </Stack>
    </Stack>
  );
};
